import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';

export const getFormGroupFromModel = (model, index?) => {
  const formGroupObject: any = {};
  Object.keys(model)
    .forEach((key: string) => {
      formGroupObject[key] = new UntypedFormControl(model[key]);
    });
  if (index) {
    formGroupObject.index = new UntypedFormControl(index);
  }
  return new UntypedFormGroup(formGroupObject);
};
